import styles from "./SearchTitleCounts.module.scss";
import { FormattedMessage } from "react-intl";
import { SearchTitlesFilterType } from "../results/useAllTitleResults.ts";
import ChipGroup from "../../../../common/core-ui/ChipGroup.tsx";

interface SearchTitleCountsProps {
  value: SearchTitlesFilterType;
  query: string;
  curCount: number;
  totalCount: number;
  exploreTotal: number;
  storeTotal: number;
  onChange: (value: SearchTitlesFilterType) => void;
  onClear: () => void;
}

export default function SearchTitleCounts({
  value,
  query,
  curCount,
  totalCount,
  exploreTotal,
  storeTotal,
  onChange,
  onClear,
}: SearchTitleCountsProps) {
  return (
    <div className={styles.container}>
      <div className={styles.allTitlesHitCount}>
        <FormattedMessage
          defaultMessage="{rangeStart} - {rangeEnd} of {totalCount} results for “{searchTerm}”"
          values={{
            rangeStart: 1,
            rangeEnd: curCount,
            totalCount: totalCount,
            searchTerm: query,
          }}
        />
      </div>
      {exploreTotal > 0 && storeTotal > 0 && (
        <ChipGroup<SearchTitlesFilterType>
          type={"exclusive"}
          name={"titleFilter"}
          legend={<FormattedMessage defaultMessage="Filter title results" />}
          value={value}
          onChange={onChange}
          onClear={onClear}
          options={[
            {
              label: (
                <FormattedMessage
                  defaultMessage="Available in Explore ({count})"
                  values={{
                    count: exploreTotal,
                  }}
                />
              ),
              value: "exploreResults",
            },
            {
              label: (
                <FormattedMessage
                  defaultMessage="For Purchase ({count})"
                  values={{
                    count: storeTotal,
                  }}
                />
              ),
              value: "storeResults",
            },
          ]}
        />
      )}
    </div>
  );
}
